export default {"src":"/_next/static/media/pdf-grey.950162d0.svg","height":23,"width":19};